export default __webpack_public_path__ + "static/media/three_dots.ec7a0812.svg";